import Bugsnag from '@bugsnag/node';
import * as BugsnagCore from '@bugsnag/core';

import {loadPackageJson} from './utils.js';

let BugsnagClient: BugsnagCore.Client | undefined;

function setupBugsnag(disableBugsnag: boolean) {
  if (disableBugsnag) {
    return;
  } else if ((Bugsnag as any)._client) {
    return Bugsnag;
  }

  const packageJson = loadPackageJson();

  const bugsnagServerOptions: BugsnagCore.Config = {
    apiKey: '21fd37fe87ead4b9c5a8eed90752b455',
    autoDetectErrors: true,
    appVersion: packageJson.version,
    endpoints: {
      notify: 'https://error-analytics-production.shopifysvc.com',
      sessions: 'https://error-analytics-sessions-production.shopifysvc.com',
    },
    logger: null,
  };

  return (Bugsnag as any).start(bugsnagServerOptions);
}

export function initializeBugsnag(disableBugsnag: boolean) {
  BugsnagClient = setupBugsnag(disableBugsnag);
}

export function getBugsnag() {
  return BugsnagClient;
}

export function sanitizeError(
  error: Error | string,
  rootPath?: string,
): Error | string {
  if (!rootPath) {
    return error;
  }

  const replaceRootPath = (message: string) => {
    return message.replace(new RegExp(rootPath, 'g'), '***');
  };

  if (error instanceof Error) {
    const cleanError = Object.create(Object.getPrototypeOf(error));
    Object.assign(cleanError, error, {
      message: replaceRootPath(error.message),
      stack: error.stack ? replaceRootPath(error.stack) : undefined,
    });

    return cleanError;
  }

  return replaceRootPath(error);
}
